import { useCallback } from "react";
import { NavLink, NavLinkProps, NavLinkRenderProps } from "react-router";

/**
 * A wrapper around react-router's `<NavLink>` that adds Bootstrap's `nav-item` class and handles the `active` state.
 *
 * NOTE: If active styling is not needed for the link, consider using the `Link` component directly from react-router instead.
 */
export const BootstrapDropdownNavItem: React.FC<NavLinkProps & React.RefAttributes<HTMLAnchorElement>> = ({
  className,
  ...props
}) => {
  // Define a function to get the class name based on the isActive prop, while respecting any additional class names passed in
  const getClassName = useCallback(
    (renderProps: NavLinkRenderProps) => {
      const classes = [
        "dropdown-item",
        typeof className === "function" ? className(renderProps) : className,
        renderProps.isActive ? "active" : "",
      ];
      return classes.filter(Boolean).join(" ").trim();
    },
    [className],
  );

  return <NavLink {...props} className={getClassName} />;
};
